import { useContext, useMemo } from 'react';

import i18n from '@nextroll/ar-i18n';
// @ts-ignore - no types for ar-style-base
import { Logo, ThemeLoaderTitle } from '@nextroll/ar-style-base';

// @ts-ignore - no types for an image.
import MetricsUIRW from '../../assets/standard-sign-up/metrics-ui-rw.png';
// @ts-ignore - no types for an image.
import MetricsUI from '../../assets/standard-sign-up/metrics-ui.png';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import {
    BU_ROLLWORKS,
    SIGNUP_TRUSTED_BRANDS,
    SignUpModes,
} from '../../constants';
import ThemeWrapperContext from '../../contexts/ThemeWrapperContext';
import SignUpForm from '../../forms/sign-up/SignUpForm';

const srcMetricsUI = `${process.env.STATIC_PATH}${MetricsUI}`;
const srcMetricsUIRW = `${process.env.STATIC_PATH}${MetricsUIRW}`;

interface ISignUpPageProps {
    singleColumnForm?: boolean;
}

const SignUpPage = ({ singleColumnForm = false }: ISignUpPageProps) => {
    const { businessUnit, buName } = useContext(ThemeWrapperContext);

    const title = useMemo(
        () => (
            <h1>
                {businessUnit === BU_ROLLWORKS
                    ? i18n.gettext('Predict, activate, and measure your')
                    : i18n.gettext('Smarter ads. Stronger results.')}
                <br />
                {businessUnit === BU_ROLLWORKS
                    ? i18n.gettext('pipeline — all powered by trusted AI.')
                    : i18n.gettext('All powered by AI you can trust.')}
            </h1>
        ),
        [businessUnit]
    );

    const trustedBrands = useMemo(
        () => (
            <div className='signup-exp2-brands'>
                <p>
                    {businessUnit === BU_ROLLWORKS
                        ? i18n.gettext('Trusted by the Best in B2B')
                        : i18n.gettext('Trusted by 110,000+ brands')}
                </p>
                <br />
                <div role='list'>
                    {SIGNUP_TRUSTED_BRANDS[businessUnit]?.map(
                        ({ name, logo }) => (
                            <img
                                role='listitem'
                                key={name}
                                src={logo}
                                alt={name}
                            />
                        )
                    )}
                </div>
            </div>
        ),
        [businessUnit]
    );

    const content = (
        <section className='eh-page eh-page-signup-exp2 eh-sign-up-content'>
            <link
                href='https://fonts.googleapis.com/css2?family=Work+Sans:wght@700&display=swap'
                rel='stylesheet'
            />

            {/* left panel */}
            <div className='signup-exp-2-content-left'>
                <Header className='signup-exp2-header' />
                <div className='signup-exp2-chart'>
                    <img
                        src={
                            businessUnit === BU_ROLLWORKS
                                ? srcMetricsUIRW
                                : srcMetricsUI
                        }
                        alt='Website metrics'
                    />
                </div>
                <div className='signup-exp2-description'>
                    {title}
                    <p>
                        {businessUnit === BU_ROLLWORKS
                            ? i18n.gettext(
                                  'Personalized ads, predictive insights, and GTM orchestration — built to grow your business and simplify marketing.'
                              )
                            : i18n.gettext(
                                  'Personalized, privacy-first advertising solutions designed to grow your business and simplify your marketing.'
                              )}
                    </p>
                </div>
                {trustedBrands}
            </div>

            {/* right panel */}
            <div className='signup-exp-2-content-right'>
                <Header className='signup-exp2-header' />
                {title}
                <SignUpForm
                    mode={SignUpModes.STANDARD}
                    singleColumnLayout={singleColumnForm}
                />
            </div>

            {/* footer, which is always floating */}
            <Footer />
        </section>
    );

    return (
        <>
            <ThemeLoaderTitle
                title={buName}
                subtitle={i18n.gettext('Sign Up')}
            />
            {content}
        </>
    );
};

export default SignUpPage;
